import React from "react"
import styled from "styled-components"
import NextImg from "@/common/components/NextImg"

export default function AnswerCard({ content, type, customFor }) {
  return (
    <Wrapper>
      {customFor === "WEB3Plus" && (
        <BGWrapper>
          <Decoration className={"c1"} />
          <Decoration className={"c2"} />
          <Decoration className={"c3"} />
          <Decoration className={"c4"} />
        </BGWrapper>
      )}
      {type === "Image" ? (
        <ImageWrapper>
          <NextImg src={content} />
        </ImageWrapper>
      ) : (
        <p>{content}</p>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  cursor: pointer;
  border: #00ffeeba 1px solid;
  background-color: #00000088;
  border-radius: 16px;
  padding: 20px;
  backdrop-filter: blur(3px);
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
  transition: 0.3s;
  @media (max-width: 768px) {
    padding: 16px 16px;
    border-radius: 16px;
  }
  p {
    margin: 0;
    color: #00fff0;
    transition: 0.3s;
    font-size: 16px;
  }
  @media (min-width: 769px) {
    &:hover {
      background-color: #00fff0;
      box-shadow: 0 0 30px #00fff0;
      p {
        color: #000;
      }
    }
  }
  &:before {
    content: "";
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 0.1px solid #00fff0;
    position: absolute;
    transition: all 0.3s;
    border-radius: 16px;
    box-sizing: content-box;
  }
  &:active {
    scale: 1.05;
    opacity: 1;
    position: relative;
    background-color: #00fff0;
    box-shadow: 0 0 30px #00fff0;
    p {
      color: #000;
    }
    /* visibility: visible; */
    &:before {
      animation: answerActive 0.1s forwards;
    }
    @keyframes answerActive {
      100% {
        padding: 30px;
        border-radius: 16px;
        border: 0.1px solid #00ffee36;
      }
    }
  }
`

const ImageWrapper = styled.div`
  width: 100%;
  position: relative;
`
const BGWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
`
const Decoration = styled.div`
  --decoration: 16px;
  position: absolute;
  border-top: 5px solid #00ffeeba;
  border-left: 5px solid #00ffeeba;
  width: var(--decoration);
  height: var(--decoration);
  border-radius: 16px 0 0 0;
  &.c1 {
    top: -2px;
    left: -2px;
  }
  &.c2 {
    top: -2px;
    right: -2px;
    transform: rotate(90deg);
  }
  &.c3 {
    bottom: -2px;
    left: -2px;
    transform: rotate(270deg);
  }
  &.c4 {
    bottom: -2px;
    right: -2px;
    transform: rotate(180deg);
  }
`
